import script from "./PersonalSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalSetting.vue?vue&type=script&setup=true&lang=js"

import "../../assets/css/pc/infoModify.css?vue&type=style&index=0&id=32d3aee9&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d3aee9"]])

export default __exports__